import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEasyQuoting = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "easyQuoting",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12656",
			"data-name": "Path 12656",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12657",
			"data-name": "Path 12657",
			d: "M16,21H8a2,2,0,0,1-2-2V5A2,2,0,0,1,8,3h8a2,2,0,0,1,2,2V19A2,2,0,0,1,16,21Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12659",
			"data-name": "Path 12659",
			d: "M10.75,6h2.5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12660",
			"data-name": "Path 12660",
			d: "M12,6.68V6",
			transform: "translate(0.001 4.279)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12661",
			"data-name": "Path 12661",
			d: "M12,13v.68",
			transform: "translate(0.001 2.041)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12662",
			"data-name": "Path 12662",
			d: "M10.18,10.6a.981.981,0,0,0,.841.488h.746A.955.955,0,0,0,12,9.2l-1.276-.32A.956.956,0,0,1,10.955,7H11.7a.982.982,0,0,1,.84.486",
			transform: "translate(0.64 3.959)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgEasyQuoting;
